import { Text, HStack, Flex, Box } from "@chakra-ui/react";
import { Avatar } from "./Avatar";

export function PeoplePile({
  readerAvatarsUrls,
  readersCount,
}: {
  readerAvatarsUrls: string[];
  readersCount: string;
}) {
  return (
    <HStack gap={2} alignItems="center">
      <Flex direction="row">
        {readerAvatarsUrls.map((avatar, index) => (
          <Box
            key={index}
            // Force negative margin on all but the first item
            ms={index === 0 ? 0 : "-12px"}
            zIndex={readerAvatarsUrls.length - index}
            // Ensures the border doesn't shrink the avatar
            flexShrink={0}
          >
            <Box borderRadius="full" overflow="hidden">
              <Avatar size="sm" imageSrc={avatar} isGold />
            </Box>
          </Box>
        ))}
      </Flex>

      <Text variant="paymentTestimonialReadersCount">{readersCount}</Text>
    </HStack>
  );
}
